import { useEffect, useState } from 'react';
import { useSync } from '../sync/useSync';

export default function OnlineBadge() {
  const [online, setOnline] = useState(navigator.onLine);
  const { busy } = useSync();

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return (
    <div className="topbar">
      <span className={`dot ${online ? 'on' : 'off'}`} />
      <span>{online ? (busy ? 'Syncing…' : 'Online') : 'Offline — readings are saved on this phone'}</span>
    </div>
  );
}
